import React from 'react';
import styled from 'styled-components';

const StyledItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .item-content{
        display: flex;
        flex-direction: column;
    }
    .illustration{
        max-width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px auto 0;
        img{
            display: block;
            max-width: 100%;
        }
    }
`;

export default ({ title, content, src }) => (
    <StyledItem>
        <div className="item-content">
            <h2>{title}</h2>
            <p>{content}</p>
        </div>
        {src && (
            <div className="illustration">
                <img alt={title} src={src} />
            </div>
        )}
    </StyledItem>
);
